import { render, staticRenderFns } from "./kematian.vue?vue&type=template&id=29744f40&scoped=true&"
import script from "./kematian.vue?vue&type=script&lang=js&"
export * from "./kematian.vue?vue&type=script&lang=js&"
import style0 from "./kematian.vue?vue&type=style&index=0&id=29744f40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29744f40",
  null
  
)

export default component.exports